import bs58 from "bs58";

const TOTAL_BITS = 5 + 37 + 4 + 2 + 5 + 10 + 37;
const TOTAL_BYTES = Math.ceil(TOTAL_BITS / 8);

export interface ProfileTokenPayload {
  userId: number;
  referrerId?: number;
  version?: number;
  screen?: number;
  method?: number;
  context?: number;
  elementId?: number;
}

export interface DecodedProfileToken {
  version: number;
  userId: number;
  screen: number;
  method: number;
  context: number;
  elementId: number;
  referrerId: number;
}

export const generateProfileToken = ({
  userId,
  referrerId = 0,
  version = 1,
  screen = 2,
  method = 0,
  context = 4,
  elementId = 0,
}: ProfileTokenPayload): string => {
  const fields: Array<[number, number]> = [
    [version, 5],
    [userId, 37],
    [screen, 4],
    [method, 2],
    [context, 5],
    [elementId, 10],
    [referrerId, 37],
  ];

  let bits = "";
  for (const [val, len] of fields) {
    bits += Number(val).toString(2).padStart(len, "0");
  }

  const num = BigInt("0b" + bits);
  const buf: number[] = [];
  for (let i = TOTAL_BYTES - 1; i >= 0; --i) {
    buf.push(Number((num >> BigInt(i * 8)) & BigInt(0xff)));
  }

  return bs58.encode(Uint8Array.from(buf));
};

export const decodeProfileToken = (encoded: string): DecodedProfileToken => {
  const buf: Uint8Array = bs58.decode(encoded);
  let bits = "";
  for (const byte of buf) {
    bits += byte.toString(2).padStart(8, "0");
  }
  bits = bits.slice(bits.length - TOTAL_BITS);

  const read = (n: number): number => {
    const out = bits.slice(0, n);
    bits = bits.slice(n);

    return parseInt(out, 2);
  };

  const version = read(5);
  const userId = read(37);
  const screen = read(4);
  const method = read(2);
  const context = read(5);
  const elementId = read(10);
  const referrerId = read(37);

  return { version, userId, screen, method, context, elementId, referrerId };
};
